import React from 'react'
// assets 
import img1 from '../../Assets/Group 3320.png'
import img2 from '../../Assets/Group 3319.png'
import img3 from '../../Assets/Group 3318.png'
import img4 from '../../Assets/Group 3317.png'
const Trusted = () => {
    return (
        <div className='trusted_container'>
            <div className="trusted_md">
                <h4>Trusted by</h4>
                <div className="trusted_slides">
                    <div>
                        <img src={img1} alt="..." />
                    </div>
                    <div>
                        <img src={img2} alt="..." />
                    </div>
                    <div>
                        <img src={img3} alt="..." />
                    </div>
                    <div>
                        <img src={img4} alt="..." />
                    </div>
                    <div>
                        <img src={img1} alt="..." />
                    </div>
                    <div>
                        <img src={img2} alt="..." />
                    </div>
                    <div>
                        <img src={img3} alt="..." />
                    </div>
                    <div>
                        <img src={img4} alt="..." />
                    </div>
                    <div>
                        <img src={img1} alt="..." />
                    </div>
                    <div>
                        <img src={img2} alt="..." />
                    </div>
                    <div>
                        <img src={img3} alt="..." />
                    </div>
                    <div>
                        <img src={img4} alt="..." />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Trusted
